'use client'

import FloatChat from "@/components_mobile/float/chat"
import FloatMenu from "@/components_mobile/float/menu"
import { createContext, ReactNode, useContext, useEffect, useState } from "react"
import FloatBackBtn from "@/components_mobile/etc/float_back_btn";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { pushHistory, endBackNavigation, getIsBackNavigation, historyStack, isBackDisabled } from "@/type/historyStack"; 
import { useNav } from "./navContext";
import FloatMenuBottom from "@/components_mobile/float/menuBottom";
import FloatMyPageRight from "@/components_mobile/float/mypge_right";
import { AuthContext } from "./authContext";

interface floatTypes {
    // isActive: boolean
    // SetActive: (set: boolean)=> void
    mypageShow: boolean
    SetMypageShow: (set: boolean)=> void
    quickMenuShow: boolean
    setQuickMenuShow: (set: boolean)=> void
    setBottomActive: (set: boolean)=> void
}
export const FloatContext = createContext<floatTypes>({
    // isActive: false,
    // SetActive: ()=> {},
    mypageShow: false,
    SetMypageShow: ()=> {},
    quickMenuShow:false,
    setQuickMenuShow: ()=> {},
    setBottomActive: ()=> {}

})

interface MoFloatMenuContextType {
  isDisabled: boolean;
  setIsDisabled: (value: boolean) => void;
}
export const MoFloatMenuContext = createContext<MoFloatMenuContextType | null>(null);

export const useMoFloatMenu = () => {
  const ctx = useContext(MoFloatMenuContext)
  if (!ctx) {
    console.warn("⚠️ MoFloatMenuContext를 찾을 수 없습니다. Provider로 감싸져 있나요?");
    return { isDisabled: false, setIsDisabled: () => {} }
  }
  return ctx
}


export default function MoFloatMenuProvider({children}: {children: ReactNode}) {
    const {movePage} = useNav();
    // const [isActive, setActive] = useState<boolean>(false)
    const [mypageShow, setMypageShow] = useState<boolean>(false)
    const [bottomIsActive, setBottomActive] = useState<boolean>(false)
    const [showChat, setShowChat] = useState<boolean>(false)
    const [isDisabled, setIsDisabled] = useState(false);
    const [quickMenuShow, setQuickMenuShow] = useState<boolean>(false)

    
    const [reloadMenuShow, setReloadMenuShow] = useState<boolean>(false)
    const [toTopMenuShow, setToTopMenuShow] = useState<boolean>(true)
    const [goHomeShow, setGoHomeShow] = useState<boolean>(false)

    


    const router = useRouter();
    const pathname = usePathname();

        
    

    // function SetActive(set: boolean){
    //     setActive(set)
    // }
    function SetMypageShow(set: boolean){
        setMypageShow(set)
    }

    const propsValue = {
        mypageShow,
        SetMypageShow,
        quickMenuShow,
        setQuickMenuShow,
        setBottomActive
    }
    
    const searchParams = useSearchParams();
    function push() {
        const fullPath = searchParams.toString()
            ? `${pathname}?${searchParams.toString()}`
            : pathname;

        if (!getIsBackNavigation()) {
            pushHistory(fullPath);
        } else {
            endBackNavigation();
        }
        setIsDisabled(isBackDisabled())
        // console.log("** [MoFloatMenuContext] History push:", historyStack);
    }

    useEffect(() => {
        // 20250929 뒤로가기삭제
        // if (pathname){
        //     push()
        // }
        if(pathname == '/'){
            setGoHomeShow(false)
            setReloadMenuShow(true)
        }else{
            setGoHomeShow(true)
            setReloadMenuShow(false)
        }
    }, [pathname,searchParams]);


    useEffect(() => {


        const handleScroll = () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            if (scrollY === 0) {
                if(pathname == '/'){
                    setReloadMenuShow(true)
                }else{
                    setGoHomeShow(true)
                }
                setToTopMenuShow(false)
            } else if (scrollY >= 100) {
                setGoHomeShow(false)
                setReloadMenuShow(false)
                setToTopMenuShow(true)
            }
        };

        
    // let startY = 0;
    // let isPulling = false;

    // const handleTouchStart = (e: TouchEvent) => {
    //     if (window.scrollY === 0) {
    //         startY = e.touches[0].clientY;
    //         isPulling = true;
    //     } else {
    //         isPulling = false;
    //     }
    // }
    // const handleTouchMove = (e: TouchEvent) => {
    //     if (!isPulling) return;
    //     const currentY = e.touches[0].clientY;
    //     const diff = currentY - startY;

    //     if (diff > 70) { 
    //         location.reload();
    //         isPulling = false;
    //     }
    // };

        handleScroll();
        window.addEventListener("scroll", handleScroll);
        // window.addEventListener("touchstart", handleTouchStart);
        // window.addEventListener("touchmove", handleTouchMove);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            // window.removeEventListener("touchstart", handleTouchStart);
            // window.removeEventListener("touchmove", handleTouchMove);
        };
    }, [pathname]);

    
    return (
        <MoFloatMenuContext.Provider value={{ isDisabled, setIsDisabled }}>
            <FloatContext.Provider value={propsValue}>
                {children}

                <div className={`floatingArea`}>
                    {/* 20250929 플로팅버튼삭제 */}
                   {/*  <div className={`quick-menu-container ${quickMenuShow ? "show" : ""}`}>
                        <div className="fl-menu-button move-home-icon" 
                             onClick={e=> {
                                movePage('/'); 
                                setQuickMenuShow(false);}
                             }></div>
                        <div className="fl-menu-button chat-show-icon" 
                             onClick={e=> {
                                setShowChat(true); 
                                setQuickMenuShow(false);}
                             }></div>
                        <div className="fl-menu-button menu-show-icon" 
                             onClick={e=> {
                                setBottomActive(!bottomIsActive); 
                                setQuickMenuShow(false);}
                             }></div>
                    </div> */}
                    <div className="default-menu">
                        {/* <div className="fl-menu-button chat-show-icon" onClick={e=> setShowChat(true)}></div> */}
                        {/* <div className={`fl-menu-button quick-menu ${!quickMenuShow ? 'plus' : 'minus' }`} onClick={e=> setQuickMenuShow(!quickMenuShow)}></div> */}
                        <div className="fl-menu-button menu-show-icon" 
                             onClick={e=> {
                                setBottomActive(!bottomIsActive); 
                                setQuickMenuShow(false);
                            }
                             }></div>

                        {/* 
                            20250929 뒤로가기삭제 
                                     상단으로, 새로고침 추가
                        */}
                        {/* <FloatBackBtn disabled={isDisabled} /> */}
                        <div className={`fl-menu-button menu-reload-icon ${reloadMenuShow ? "" : "hide"}`} 
                             onClick={e=> {
                                location.reload();
                             }
                             }></div>
                        <div className={`fl-menu-button menu-home-icon ${goHomeShow ? "" : "hide"}`} 
                             onClick={e=> {
                                router.push('/')
                             }
                             }></div>
                        <div className={`fl-menu-button menu-toTop-icon ${toTopMenuShow ? "" : "hide"}`} 
                             onClick={e=> {
                                window.scrollTo({ top: 0 });
                             }
                             }></div>

                    </div>
                </div>
                <FloatMenuBottom isActive={bottomIsActive} 
                                setActive={setBottomActive}
                                setShowChat={setShowChat} />
                <FloatMyPageRight isActive={mypageShow} setActive={setMypageShow} />
                {/* <FloatMenu isActive={isActive} setActive={setActive} /> */}
                <FloatChat showChat={showChat} setShowChat={setShowChat} />
            </FloatContext.Provider>
        </MoFloatMenuContext.Provider>
    )
}
